export class UrlHelper {
    static getQueryString(name: string, url: string = null, caseSensitive = false, replacePlusWithSpace = false): string {
        if (!url) url = window.location.href;
        name = name.replace(/[[\]]/g, "\\$&");
        const expression = "[?&]" + name + "(=([^&#]*)|&|#|$)";
        const regex = caseSensitive ? new RegExp(expression) : new RegExp(expression, "i");
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        const replacedResult = replacePlusWithSpace ? results[2].replace(/\+/g, " ") : results[2];
        return decodeURIComponent(replacedResult);
    }

    static clearUrlParams(urlParams?: string[], caseSensitive = false) {
        if (!urlParams?.length) {
            return;
        }
        let newUrl = window.location.href;
        for (const parameter of urlParams) {
            newUrl = newUrl
                .replace(
                    caseSensitive
                        ? new RegExp("[?&]" + parameter + "=[^&#]*(#.*)?$")
                        : new RegExp("[?&]" + parameter + "=[^&#]*(#.*)?$", "i"),
                    "$1",
                )
                .replace(
                    caseSensitive ? new RegExp("([?&])" + parameter + "=[^&]*&") : new RegExp("([?&])" + parameter + "=[^&]*&", "i"),
                    "$1",
                );
        }
        if (window.history && window.location.href != newUrl) {
            window.history.replaceState(null, document.title, newUrl);
        }
    }

    static clearUrlParam(urlParam: string) {
        this.clearUrlParams([urlParam]);
    }
}
